module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "IS-EB-5P-1.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('h1', {
    attrs: {
      "id": "toc_marker-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "Anchor"
    }
  }, [_vm._v("Copyright Information")])]), _c('a', {
    attrs: {
      "id": "Anchor"
    }
  }, [_c('p', [_vm._v("Edited by George Beahm")]), _vm._v(" "), _c('p'), _c('p', [_vm._v("Copyright © 2011 by George Beahm")]), _vm._v(" "), _c('p', [_vm._v("No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system, without express written permission from the publisher.")]), _vm._v(" "), _c('p'), _c('p', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I, Steve")]), _vm._v(" was in no way authorized, prepared, approved, or endorsed by Steve Jobs and is not affiliated with or endorsed by any of his organizations.")]), _vm._v(" "), _c('p'), _c('p', [_vm._v("First ebook edition November 2011.")]), _vm._v(" "), _c('p'), _c('p', [_vm._v("ISBN-10 1-57284-693-3")]), _vm._v(" "), _c('p', [_vm._v("ISBN-13 978-1-57284-693-7")]), _vm._v(" "), _c('p'), _c('p', [_vm._v("This ebook edition of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I, Steve")]), _vm._v(" includes corrections made after the book’s earlier printings.")]), _vm._v(" "), _c('p'), _c('p', [_vm._v("B2 Books is an imprint of Agate Publishing, Inc. Agate books are available in bulk at discount prices. For more information, go to agatepublishing.com.")])])]), _c('a', {
    attrs: {
      "id": "Anchor"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05a465ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IS-EB5P-1.vue
// module id = 60
// module chunks = 0